import SvgElement from './SvgElement.js';
import HtmlUtils from "../../components/HtmlUtils.js";

export default class Area {
    /** @param domElement */
    constructor(domElement) {
        this._rootElement = domElement;
    }

    /** @return {SvgElement} */
    drawRect(x, y, width, height, cssClass = '') {
        const node = this._createElement('rect');
        return new SvgElement(node)
            .attr('class', cssClass)
            .attr('x', x).attr('y', y)
            .attr('width', width).attr('height', height)
    }

    /** @return {SvgElement} */
    drawCircle(x, y, r, cssClass = '') {
        const node = this._createElement('circle');
        return new SvgElement(node)
            .attr('class', cssClass)
            .attr('cx', x).attr('cy', y).attr('r', r)
    }
    /** @return {SvgElement} */
    drawLine(x0, y0, x1, y1, cssClass){
        return this.drawPath([{x:x0, y:y0}, {x:x1,y:y1}], cssClass)
    }

    /** @return {SvgElement} */
    drawPath(data, cssClass = '') {
        const node = this._createElement('path');
        const path = this._isArrayWithElements(data)
            ? d3.line().x(d => d.x).y(d => d.y)(data)
            : data;
        return new SvgElement(node)
            .attr("class", cssClass)
            .attr("d", path);
    }

    /** @return {SvgElement} */
    drawText(x, y, text, cssClass = '') {
        const node = this._createElement('text');
        return new SvgElement(node)
            .attr("class", cssClass)
            .attr('x', x).attr('y', y)
            .text(text);
    }

    /** @return {SvgElement} */
    drawArea(data, cssClass){
        const node = this._createElement('path');
        const path = this._isArrayWithElements(data)
            ? d3.area().x(d => d.x).y0(d => d.y0).y1(d => d.y)(data)
            : data;
        return new SvgElement(node)
            .attr("class", cssClass || "area")
            .attr("d", path);
    }

    clear() {
        const root = this._rootElement;
        while (root.firstChild)
            root.removeChild(root.firstChild)
    }

    remove() {
        this._rootElement.remove();
    }

    /** @return {Area} */
    createChild(tagName = 'g', className = ''){
        return new Area(this._createElement(tagName, className))
    }

    size() {
        // In case if the root element is 'g', then we need to get the size of parent SVG
        const brc = HtmlUtils.getParentSvgSize(this._rootElement);
        return {width: brc.width, height: brc.height};
    }

    /** @param {boolean} v */
    setVisible(v) {
        v ? this.show() : this.hide();
    }
    show() {
        this._rootElement.style.display = 'block';
    }

    hide() {
        this._rootElement.style.display = 'none';
    }

    domElement() {
        return this._rootElement;
    }

    _createElement(tagName, className = ''){
        const name = d3.create(`svg:${tagName}`).classed(className, true);
        return this._rootElement.appendChild(name.node())
    }

    _isArrayWithElements(data) {
        return Array.isArray(data) && data.length > 0;
    }
}
